import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { Reveal } from '../components/Reveal';
interface Engagement {
  label: string;
  title: string;
  points: string[];
}
const engagements: Engagement[] = [{
  label: 'Sell-side preparation',
  title: 'Confidential Information Memoranda',
  points: ['Trillium Software — key member of the management team responsible for the carve-out sale from Harte Hanks, including CIM development, due diligence, and management presentations.', 'Information Builders — partnered with executive leadership, financial stakeholders, and investment banking teams on the CIM supporting the company’s strategic sale.', 'Accelerate Learning — partnered with executive and financial stakeholders on the development and evaluation of the CIM supporting the strategic sale process.']
}, {
  label: 'Buy-side diligence',
  title: 'Acquisition strategy & technical due diligence',
  points: ['Defined acquisition product strategy and market adjacencies at Syncsort, overseeing technical due diligence contributing to eight worldwide acquisitions.', 'Led M&A due diligence and post-acquisition integration for Finland-based Kide Science at Accelerate Learning.', 'Assessed product fit, architecture risk, roadmap overlap, and commercial synergy ahead of investment decisions.']
}, {
  label: 'Post-merger integration',
  title: 'Making acquisitions operate as one portfolio',
  points: ['Led post-acquisition product integration at IBM, aligning Ascential technologies with the broader InfoSphere roadmap.', 'Integrated acquired product lines into a coherent portfolio architecture as Syncsort tripled in size.', 'Consolidated pricing, packaging, and launch processes across newly combined product organizations.']
}, {
  label: 'Board & sponsor partnership',
  title: 'Working with boards, bankers, and sponsors',
  points: ['Partnered with executive leadership and the Board to define forward-looking Big Data and cloud strategies.', 'Reported directly to the CEO in three consecutive executive appointments.', 'Translated product and architecture decisions into portfolio economics for private equity stakeholders.']
}];
export function CorporateDevelopment() {
  return <>
      <PageHeader number="06" title="M&A & Corporate Development" blurb="CIM authorship, technical due diligence, and post-merger integration." data-id="element-207" data-mp="1za91k2hzwasx" />

      <section className="bg-paper py-20 lg:py-24" data-id="element-208" data-mp="28zshazaevojk">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-209" data-mp="291dekwo41ll4">
          <Reveal data-id="element-210" data-mp="247iy023sxmq9">
            <p className="max-w-3xl font-display text-2xl font-light leading-[1.6] text-navy" data-id="element-211" data-mp="246zies1mjafe">
              Eight worldwide acquisitions, three sale processes, and one international
              post-merger integration — product leadership applied directly to transaction
              outcomes.
            </p>
          </Reveal>

          <div className="mt-14 space-y-0" data-id="element-212" data-mp="3rxyl6hxvf4nd">
            {engagements.map((e, i) => <Reveal key={e.title} delay={Math.min(i * 0.04, 0.12)} data-id="element-213" data-mp="3s01htktj3w12" data-mpi={i}>
                <article className="grid gap-6 border-t border-navy/15 py-10 lg:grid-cols-12 lg:gap-16" data-id="element-214" data-mp="3e84x41u6woep">
                  <header className="lg:col-span-4" data-id="element-215" data-mp="3i8ow7aybq23h">
                    <p className="text-[11px] uppercase tracking-overline text-gold" data-id="element-216" data-mp="9ru1iirojo0h">{e.label}</p>
                    <h2 className="mt-4 font-display text-2xl font-light leading-snug text-navy" data-id="element-217" data-mp="eryjkd88kqst">
                      {e.title}
                    </h2>
                  </header>
                  <ul className="space-y-5 lg:col-span-8" data-id="element-218" data-mp="5qqjbpm5tfw3">
                    {e.points.map(p => <li key={p} className="flex gap-4" data-id="element-219" data-mp="2li62lqx87z2n">
                        <span aria-hidden="true" className="mt-[11px] h-px w-5 shrink-0 bg-gold" data-id="element-220" data-mp="2lgl7o0702e49" />
                        <span className="text-[15px] leading-[1.75] text-steel" data-id="element-221" data-mp="2qial1mhp33vi">{p}</span>
                      </li>)}
                  </ul>
                </article>
              </Reveal>)}
          </div>
        </div>
      </section>

      <SectionPager current="/corporate-development" data-id="element-222" data-mp="2w01ks2lac4fe" />
    </>;
}